<pages-menu *ngIf="show"></pages-menu>
<div class="right-banner">
        <img src="assets/images/banner/lider.png" alt="">

        <img src="assets/images/banner/brand.jpeg" alt="">

    <div class="right-banner-img"></div>
</div>
